import { render, staticRenderFns } from "./CompanyDialog.vue?vue&type=template&id=f50fe838"
import script from "./CompanyDialog.vue?vue&type=script&lang=js"
export * from "./CompanyDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports